<section class="add-user-dialog" aria-label="Add organization user">
  <header class="add-user-dialog__header">
    <div>
      <p class="add-user-dialog__eyebrow">Organization User</p>
      <h2>{{ dialogTitle() }}</h2>
      <p>{{ dialogDescription() }}</p>
    </div>

    <button type="button" mat-icon-button aria-label="Close add user dialog" (click)="close()">
      <mat-icon aria-hidden="true">close</mat-icon>
    </button>
  </header>

  <form class="add-user-dialog__form" [formGroup]="form" (ngSubmit)="submit()" novalidate>
    <mat-form-field appearance="outline">
      <mat-label>Full name</mat-label>
      <input matInput type="text" formControlName="name" />
      @if (form.controls.name.hasError('required') && form.controls.name.touched) {
        <mat-error>Name is required.</mat-error>
      }
      @if (form.controls.name.hasError('minlength') && form.controls.name.touched) {
        <mat-error>Use at least 2 characters.</mat-error>
      }
    </mat-form-field>

    
          <mat-form-field appearance="outline">
      <mat-label>Email address</mat-label>
      <input matInput type="email" formControlName="email" />
      @if (form.controls.email.hasError('required') && form.controls.email.touched) {
        <mat-error>Email is required.</mat-error>
      }
      @if (form.controls.email.hasError('email') && form.controls.email.touched) {
        <mat-error>Enter a valid email address.</mat-error>
      }
    </mat-form-field>

    <div class="phone-container">

    <mat-form-field appearance="outline" class="code-field">
    <mat-label>Code</mat-label>
    <mat-select formControlName="countryCode">
      @for (c of countries(); track c.code) {
        <mat-option [value]="c.code">
          {{ c.flag }} {{ c.code }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="outline" class="phone-field">
      <mat-label>Phone number</mat-label>
      <input matInput type="tel" formControlName="phone" />
      @if (form.controls.phone.hasError('required') && form.controls.phone.touched) {
        <mat-error>Phone number is required.</mat-error>
      }
      
                  @if(form.controls.phone.hasError('pattern') && form.controls.phone.touched){
                  <mat-error>Enter exactly 10 digits.</mat-error>
                  }
    </mat-form-field>
    
    </div>



    

    @if (validationErrors().length) {
      <app-validation-error [errors]="validationErrors()"></app-validation-error>
    }

    <div class="add-user-dialog__actions">
      <button type="button" mat-stroked-button color="primary" (click)="close()">Cancel</button>
      <button type="submit" mat-flat-button color="primary">{{ submitLabel() }}</button>
    </div>
  </form>
</section>
